/**
 * 참고 자료(자료함) 목록·선택 시트에서 공통으로 쓰는 표시용 헬퍼.
 */

// 사람이 읽는 형식 라벨로 쓸 수 있는 확장자 (업로드 허용 형식과 자주 오는 텍스트류)
const KNOWN_EXTENSIONS = new Set([
  'pdf', 'hwp', 'hwpx', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'csv',
  'txt', 'md', 'rtf', 'odt',
  'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif', 'bmp', 'tif', 'tiff',
]);

// 서버가 형식을 구분하지 못했을 때 내려오는 값들 — 라벨로 보여줄 의미가 없다
const MEANINGLESS_TYPES = new Set(['', 'unknown', 'other', 'file', 'binary', 'multiple', 'octet-stream']);

const extensionOf = (filename) => {
  const name = String(filename || '').trim();
  const dot = name.lastIndexOf('.');
  if (dot <= 0 || dot === name.length - 1) return '';
  return name.slice(dot + 1).trim().toLowerCase();
};

/**
 * 파일 자료의 형식 라벨 (예: "PDF", "TXT", "HWPX"). 알 수 없으면 null → 라벨을 숨긴다.
 *
 * 서버 `file_type` 은 MIME 기반이라 .txt·이미지가 "Unknown" 으로 오고 Excel/PPT 처럼 뭉뚱그려지므로,
 * 원본 파일명의 확장자를 먼저 쓰고 `file_type` 은 보조로만 쓴다.
 */
export const getReferenceFileTypeLabel = (material) => {
  if (!material || material.kind !== 'file') return null;

  const ext = extensionOf(material.source_filename);
  if (ext && KNOWN_EXTENSIONS.has(ext)) return ext.toUpperCase();

  const type = String(material.file_type || '').trim().toLowerCase();
  if (type && !MEANINGLESS_TYPES.has(type)) return type.toUpperCase();

  // 목록에 없는 확장자라도 짧은 영숫자 확장자면 그대로 보여준다 (예: ODP)
  if (ext && /^[a-z0-9]{1,5}$/.test(ext)) return ext.toUpperCase();
  return null;
};

export default getReferenceFileTypeLabel;
